import { CircularProgress } from "@mui/material";

export default function LoaderSwitch({ on }) {
  return (
    <div style={{ background: "#DCDCE0", width: 41, borderRadius: 50, padding: "4px 5px", marginRight: 10, display: "flex", justifyContent: on ? "end": "initial" }}>
      <CircularProgress size={15} />
    </div>
  )
}